module.exports = __webpack_public_path__ + "img/dd1_scheme.1e9dfbea.svg";